import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      display: flex;
      flex-direction: column;
    `;
  }};
`;

export const CounterElement = styled.span`
  ${({ theme, ...props }) => {
    return css`
      position: absolute;
      right: 0;
      font-size: ${theme.typography.font_size.text_xs};
      font-weight: ${theme.typography.font_weight.text_bold};
      color: ${theme.color.neutral_500};
    `;
  }};
`;
